import {
  useState, useEffect, useCallback, PropsWithChildren,
} from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';

import { useModalContext } from '../lib/hooks';
import styles from './Item.module.css';

type ItemProps = {
  visible: boolean,
  onOutsideClick?: CallableFunction,
  vAlign?: 'flex-start' | 'center' | 'flex-end',
  hAlign?: 'flex-start' | 'center' | 'flex-end',
};

const Item = (props: PropsWithChildren<ItemProps>) => {
  const {
    children,
    visible = false,
    vAlign = 'center',
    hAlign = 'center',
    onOutsideClick,
  } = props;

  const [isMount, setMount] = useState(visible);
  const [isVisible, setVisible] = useState(visible);

  const { containerClassName } = useModalContext();

  const handleOutsideClick = useCallback((event: any) => {
    event.stopPropagation();
    event.preventDefault();
    if (onOutsideClick) {
      onOutsideClick();
    }
  }, [onOutsideClick]);

  useEffect(() => {
    if (visible) {
      setMount(true);
      setTimeout(() => {
        setVisible(true);
      }, 50);
    }
    if (!visible) {
      setVisible(false);
      setTimeout(() => {
        setMount(false);
      }, 300);
    }
  }, [visible]);

  let parent: HTMLElement | undefined;
  if (typeof document !== 'undefined') {
    parent = (document.querySelector(`.${containerClassName}`) as HTMLElement);
  }

  if (!isMount || !parent) {
    return null;
  }

  const style = {
    alignItems: vAlign,
    justifyContent: hAlign,
  };

  return createPortal(
    (
      <div
        className={classnames(styles.modalItem, { [styles.mount]: isMount, [styles.visible]: isVisible })}
        style={style}
      >
        <div
          className={styles.outside}
          onClick={handleOutsideClick}
          aria-hidden="true"
        />
        {children}
      </div>
    ),
    parent,
  );
};

export default Item;
